var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgVu = function SvgVu(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M24 12c0-.53-.035-1.053-.102-1.565H10.435l-6.92-6.92c-4.687 4.686-4.687 12.284 0 16.97l6.92-6.92h13.463c.067-.512.102-1.034.102-1.565Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F0F0F0",
    d: "m23.997 12.273-.002.07.002-.07ZM23.985 12.6c0 .023-.002.046-.004.069l.004-.069ZM23.968 12.863l-.007.101.007-.1ZM23.929 10.692l.013.12-.013-.12ZM23.98 11.33l.004.069c0-.023-.002-.046-.004-.07ZM23.995 11.657l.002.07-.002-.07ZM23.96 11.036c.004.033.006.067.008.1l-.007-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D80027",
    d: "m23.898 10.434.015.124C23.201 4.61 18.14 0 12 0a11.962 11.962 0 0 0-8.485 3.514l6.92 6.92h13.463Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6DA544",
    d: "M23.898 13.565H10.435l-6.92 6.92A11.963 11.963 0 0 0 12 24c6.14 0 11.201-4.61 11.913-10.558l-.015.123Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F0F0F0",
    d: "m23.942 13.188-.013.12.013-.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M23.969 11.137ZM23.913 10.558ZM23.941 10.812ZM24 12ZM23.981 12.669ZM23.961 12.964ZM23.928 13.308ZM23.997 11.727ZM23.985 11.398ZM23.995 12.342Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFDA44",
    d: "M23.99 11.473H9.994l-7.19-7.187a6.131 6.131 0 0 0-.64.83l6.876 6.879-6.88 6.88c.135.243.432.602.64.835l7.194-7.193H23.99a12.055 12.055 0 0 0-.002-1.044Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFDA44",
    d: "M2.915 14.557v-1.005a1.821 1.821 0 0 0 1.82-1.819c0-.71-.578-1.287-1.288-1.287a.878.878 0 0 0-.877.877c0 .31.252.56.561.56a.317.317 0 0 0 .317-.316h1.005c0 .729-.593 1.322-1.322 1.322a1.567 1.567 0 0 1-1.566-1.566c0-1.037.845-1.882 1.882-1.882a2.295 2.295 0 0 1 2.292 2.292 2.827 2.827 0 0 1-2.824 2.824Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgVu;